import { render, staticRenderFns } from "./filesAttach.vue?vue&type=template&id=06f40f88"
import script from "./filesAttach.vue?vue&type=script&lang=js"
export * from "./filesAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports